import { getInspectionImages, getLanguage, useMonkState } from '@monkvision/common';
import saveAs from 'file-saver';
import JSZip from 'jszip';
import { useTranslation } from 'react-i18next';
import { TeslaInspection } from '../useTeslaInspectionList/types';

function transformToKebabCase(input: string): string {
  return input.replace(/\s+/g, '-').toLowerCase();
}

export function useDownloadPictures() {
  const { state } = useMonkState();
  const { i18n } = useTranslation();

  const downloadPictures = async (inspection: TeslaInspection) => {
    const images = getInspectionImages(inspection.inspectionId, state.images, undefined, false);

    const promises = images.map(async (image) => {
      const res = await fetch(image.path);
      if (!res.ok) {
        throw new Error(`Failed to fetch image (HTTP ${res.status}): ${image.path}`);
      }
      const blob = await res.blob();
      if (!blob || blob.size === 0) {
        throw new Error(`Empty blob received for image: ${image.path}`);
      }
      return { blob, label: image.label?.[getLanguage(i18n.language)] };
    });

    const res = await Promise.all(promises);

    const zip = new JSZip();

    res.forEach(({ blob, label }, index) => {
      zip.file(`${label ? transformToKebabCase(label) : index}.jpg`, blob);
    });

    const zipFile = await zip.generateAsync({ type: 'blob' });
    saveAs(zipFile, `${inspection.vin}.zip`);
  };

  return {
    downloadPictures,
  };
}
